// src/maintenance.config.ts
/**
 * Maintenance configuration
 * This file is used to configure the maintenance mode of the application.
 * It is used to set the start time, estimated duration, message, and contact email for the maintenance mode.
 * It is also used to set the enabled flag to true or false to enable or disable the maintenance mode.
 * be careful not to commit this file to the repository with unintended changes.
 */

export type MaintenanceMode = 'maintenance' | 'incident' | 'resolved';

export interface IMaintenanceConfig {
  enabled: boolean;
  mode: MaintenanceMode; // 'maintenance' = full downtime page; 'incident' = banner only, app stays up
  startTime: string; // ISO 8601: '2026-04-15T02:00:00Z' — used for maintenance mode scheduling
  estimatedDuration: string; // human-readable: '~2 hours' — used for maintenance mode
  contactEmail: string; // 'support@exim.com'
  message: string; // custom message shown in the incident banner; leave empty for default text
}

export const maintenanceConfig: IMaintenanceConfig = {
  enabled: true,
  mode: 'incident',
  startTime: '',
  estimatedDuration: '',
  contactEmail: 'helpdesk@shipsy.io',
  message: "We are upgrading tracking services. a few trackings may be temporarily impacted during the ongoing upgrade activity. We’ll update you once the activity is complete.",
};
